/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdDocumentsMutationRequest,
  PutApiV1PersonIdDocumentsMutationResponse,
  PutApiV1PersonIdDocumentsPathParams,
  PutApiV1PersonIdDocuments400,
  PutApiV1PersonIdDocuments401,
  PutApiV1PersonIdDocuments404,
  PutApiV1PersonIdDocuments409,
  PutApiV1PersonIdDocuments500,
} from "../../types/personRegisterController/PutApiV1PersonIdDocuments.ts";

function getPutApiV1PersonIdDocumentsUrl(
  id: PutApiV1PersonIdDocumentsPathParams["id"],
) {
  const res = { method: "PUT", url: `/api/v1/person/${id}/documents` as const };
  return res;
}

/**
 * @description Atualiza parcialmente os documentos de uma pessoa. Valida unicidade de CPF. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/documents}
 */
export async function putApiV1PersonIdDocuments(
  id: PutApiV1PersonIdDocumentsPathParams["id"],
  data?: PutApiV1PersonIdDocumentsMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdDocumentsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdDocumentsMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdDocuments400
      | PutApiV1PersonIdDocuments401
      | PutApiV1PersonIdDocuments404
      | PutApiV1PersonIdDocuments409
      | PutApiV1PersonIdDocuments500
    >,
    PutApiV1PersonIdDocumentsMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdDocumentsUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
